import { FC, memo } from 'react';
import { Divider } from 'antd';
import { Modal } from 'shared/ui/Modal';
import { AttachmentDownloadList } from 'shared/ui';
import { Form } from 'features/Form';
import { UnFormalizedZipRequestDto } from 'shared/api';
import { UNFORMALIZED_ZIP_EDIT_FORM_FIELDS } from '../../constants/unFormalizedZipConstants';

interface UnFormalizedZipFormProps {
  isOpen: boolean;
  editingItem: UnFormalizedZipRequestDto | null;
  isEditing: boolean;
  onSubmit: (data: UnFormalizedZipRequestDto) => void;
  onCancel: () => void;
  loading?: boolean;
}

export const UnFormalizedZipForm: FC<UnFormalizedZipFormProps> = memo(({
  isOpen,
  editingItem,
  isEditing,
  onSubmit,
  onCancel,
  loading,
}) => (
  <Modal
    title={isEditing ? 'Редактировать неформализованный ЗИП' : 'Создать неформализованный ЗИП'}
    open={isOpen}
    onCancel={onCancel}
    footer={null}
    destroyOnClose
    width={600}
  >
    {loading && isEditing ? (
      <div style={{ padding: 24 }}>Загрузка данных...</div>
    ) : (
      <>
        {isEditing && (
          <>
            <AttachmentDownloadList
              attachmentUuids={editingItem?.docUrlUuids}
              label="Приложенные клиентом файлы"
              emptyText="Клиент не приложил файлов"
            />
            <Divider />
          </>
        )}
        <Form
          fields={UNFORMALIZED_ZIP_EDIT_FORM_FIELDS}
          initialValues={editingItem || {}}
          onSubmit={onSubmit}
        />
      </>
    )}
  </Modal>
));

UnFormalizedZipForm.displayName = 'UnFormalizedZipForm';
